{
    "api_keys": {
        "title": "API-Schlüssel",
        "generate_title": "API-Schlüssel erstellen",
        "label": "Label",
        "all_companies": "Alle Firmen",
        "specific_companies": "Bestimmte Firmen",
        "companies": "Firmen",
        "select_companies": "Firmen auswählen",
        "api_key_label": "API-Schlüssel",
        "columns": {
            "label": "Label",
            "api_key": "API-Schlüssel",
            "name": "Name",
            "client_id": "Client-ID",
            "companies": "Firmen",
            "created": "Erstellt",
            "expires": "Gültig bis",
            "last_used": "Zuletzt verwendet",
            "status": "Status"
        }
    },
    "card_feature": "Kartenfunktionen",
    "liquidity_management_feature": "Liquiditäts-Funktion",
    "about": "Über",
    "yes": "Ja",
    "no": "Nein",
    "action": "Aktion",
    "amount": "Betrag",
    "release_order": "Bestellung freigeben",
    "approval_needed": "Freigabe erforderlich",
    "approval_pending": "Freigabe ausstehend",
    "approval_pending_for_my_requests": "Freigabe ausstehend für meine Anträge",
    "approval_needed_purchase_order": "Freigabe erforderlich für Bestellanträge",
    "approval_needed_purchase_from": "Einkaufsfreigabe erforderlich von",
    "approval_needed_invoice_from": "Rechnungsfreigabe erforderlich von",
    "approved_by": "Freigegeben von",
    "approved": "Freigegeben",
    "approver": "Genehmiger:in",
    "procurement": "Einkauf",
    "next_approver": "Nächste Genehmiger:in",
    "second_approver": "2. Genehmiger:in",
    "docs_needed": "Dokumente erforderlich",
    "approval_pending_desc": "Sie können eine Erinnerung an den/die Freigeber:in senden.",
    "approval_confirmation": "Antrag freigeben?",
    "approval_confirmation_desc": "Der/die Antragsteller:in wird benachrichtigt.",
    "approval_confirmation_non_approver": "Antrag in der Prüfung.",
    "approval_confirmation_desc_non_approver": "Der/die Freigeber:in wurde benachrichtigt und wird den Antrag bald bearbeiten.",
    "review_confirmation": "Als geprüft markieren?",
    "review_confirmation_desc": "Bitte prüfen Sie, ob die Daten mit der Rechnung übereinstimmen.",
    "vendor_confirmation": "Bitte prüfen Sie den Lieferanten",
    "vendor_confirmation_desc": "Prüfen Sie den Lieferanten <0> {{vendorName}} </0> vor der Prüfung.",
    "review_mileage_perdiem_desc": "Bitte prüfen Sie, ob alle Daten korrekt sind.",
    "review_phase": "Antrag wird geprüft",
    "review_phase_desc": "Ein Admin wird Ihren Antrag prüfen und sicherstellen, dass die Antragsdaten mit den Rechnungsdaten übereinstimmen.",
    "mark_confirmation": "Als bezahlt markieren?",
    "mark_confirmation_desc": "Bitte überprüfen Sie ob die Bezahlung durchgeführt wurde.",
    "pay_confirmation": "Diesen Antrag bezahlen",
    "pay_confirmation_desc": "Wählen Sie aus verschiedenen Bezahlmöglichkeiten.",
    "pay_phase": "Exportiert für Zahlung",
    "pay_phase_desc": "Ein Admin wird die Zahlung dieses Antrags übernehmen.",
    "sepa_xml_confirmation": "SEPA-XML Datei erstellen?",
    "sepa_xml_confirmation_desc": "Herunterladen einer SEPA-XML Datei für Zahlung.",
    "export_sepa": "SEPA-XML Export",
    "export_non_sepa": "NON-SEPA-XML Export",
    "expense_deleted": "Gelöschter Antrag",
    "expense_deleted_desc": "Dieser Antrag wurde gelöscht.",
    "expense_rejected": "Abgelehnter Antrag",
    "expense_rejected_desc": "Dieser Antrag wurde abgelehnt.",
    "expense_archived": "Archivierter Antrag",
    "expense_archived_desc": "Dieser Antrag wurde bearbeitet und archiviert.",
    "export_confirmation": "Antrag exportieren",
    "export_confirmation_desc": "Wählen Sie aus verschiedenen Exportformaten.",
    "export_phase": "Antrag zum Exportieren bereit",
    "export_phase_desc": "Dieser Antrag kann von einem Admin exportiert werden.",
    "approved_request": "Freigegebener Antrag",
    "past_request": "Vergangener Antrag",
    "past_request_desc": "Dieser Antrag wurde verarbeitet und archiviert.",
    "article": "Artikel",
    "beta": "Beta",
    "bic": "BIC",
    "billing_period": "Abrechnungszeitraum",
    "budget": "Budget",
    "budgets": "Budgets",
    "budget_detail": {
        "status": "Ausgaben im Vergleich zur Prognose",
        "above_budget": "Über budget",
        "within_budget": "Im budget"
    },
    "city": "Stadt",
    "columns": "Spalten",
    "contact_person": "Kontaktperson",
    "cost_center_camelcase": "Kostenstelle",
    "cost_center_id": "Kostenstellen ID",
    "min_cost_center_id": "Min Kostenstellen ID",
    "max_cost_center_id": "Max Kostenstellen ID",
    "cost_center": "Kostenstelle",
    "cost_centers": "Kostenstellen",
    "costs_over_time": "Vergangene Ausgaben",
    "costs_over_time_in": "Vergangene Ausgaben ({{unit}})",
    "creation_date": "Erstellt am",
    "current_expenses": "Ausgaben",
    "currency": "Währung",
    "date_of_birth": "Geburtsdatum",
    "declined": "Abgelehnt",
    "delivery_note": "Lieferschein",
    "delivery_data": "Lieferdaten",
    "delivery_date": "Geplantes Lieferung",
    "delivery_location": "Lieferstandort",
    "created_on": "Erstellt am",
    "description": "Beschreibung",
    "documents_needed": "Dateien erforderlich",
    "documents_needed_from": "Dateien erforderlich von",
    "finway_app": "finway App",
    "phoneNumberVerified": "Telefonnummer verifiziert",
    "email": "Email-Adresse",
    "employee": "Mitarbeiter:in",
    "employees": "Mitarbeiter:innen",
    "user": "Nutzer:in",
    "users": "Nutzer:innen",
    "enrolled_in_card_program": "Im Kartenprogram registriert",
    "expenses_by_cost_center": "Ausgaben je Kostenstelle",
    "expenses": "Ausgaben",
    "team_expenses": "Ausgaben je Abteilung",
    "expense": "Ausgabe",
    "failed_to_load_files": "Laden der Dateien ist fehlgeschlagen.",
    "failed_to_load_single_file": "Laden der Datei ist fehlgeschlagen.",
    "first_name": "Vorname",
    "global_currency": "Währung",
    "hired_on": "Einstellungsdatum",
    "iban": "IBAN",
    "taxNumber": "Steuernummer",
    "vatNumber": "Umsatzsteuer-ID",
    "id": "ID",
    "invoice_pending": "Rechnungsfreigabe",
    "invoice_request_desc": "Rechnungsfreigabe und Zahlung",
    "invoice_request": "Rechnungsantrag",
    "reimbursement_request_desc": "Rückerstattung einer Auslage",
    "reimbursement_request": "Rückerstattungsantrag",
    "reimbursement_pending": "Rückerstattungsfreigabe",
    "reimbursement": "Rückerstattung",
    "min_expenses": "Min kosten",
    "max_expenses": "Max kosten",
    "invoice": "Rechnung",
    "e_invoice": "E-Rechnung",
    "last_name": "Nachname",
    "limit_x_approver": "Limit {{x}} Genehmiger:in",
    "limit_x_per_purchase": "Limit {{x}} pro Kaufantrag",
    "limits": "Limit",
    "limit_up_to": "Bis zu",
    "link": "Link",
    "location": "Standort",
    "monthly_price": "Monatlicher Preis",
    "net_monthly_price": "Monatlicher Nettopreis",
    "monthly": "Monatlich",
    "name": "Name",
    "no_doc_preview": "Keine Vorschau verfügbar.",
    "one_time_purchase": "Einmaliger Antrag",
    "one_time": "Einmalig",
    "order_description": "Beschreibung",
    "orders": "Käufe",
    "page": "Seite",
    "password": "Passwort",
    "passcode": "Finway PIN",
    "passcode_update": "Finway PIN Aktualisierung",
    "passcode_recovery": "Finway PIN Wiederherstellung",
    "past_expenses": "Vergangene Ausgaben",
    "payment": "Zahlung",
    "payment_info": {
        "billing_email": "Email-Adresse für Rechnungsstellung",
        "billing_name": "Name für Rechnungsstellung",
        "monthly_plan": {
            "info": "Kündigung jederzeit möglich"
        },
        "subscription_card": "Zahlungsart",
        "subscription_expiration_date": "Ablaufdatum",
        "subscription_next_billing": "Nächstes Abrechnungsdatum",
        "subscription_plan": "Abonnementplan",
        "subscription_status": "Abonnementstatus",
        "yearly_plan": {
            "info": "20% Rabatt"
        }
    },
    "pending_requests": "Ausstehende Anträge",
    "phone": "Telefon",
    "position": "Position",
    "profile_image": "Profilbild",
    "public_profile": "Öffentliches Profil",
    "profile": "Profil",
    "purchase_pending": "Einkaufsfreigabe",
    "purchase_request_desc": "Neuer Kaufantrag",
    "purchase_request": "Kaufantrag",
    "purchase": "Einkauf",
    "quantity": "Anzahl",
    "quantity_received": "Erhaltene Menge",
    "quantity_short": "Anz.",
    "total_net_price": "Netto",
    "unit_net_price": "Artikel Netto",
    "total_net_amount": "Netto",
    "total_gross_amount": "Brutto",
    "total_gross_amount_with_discount": "Gesamtbrutto mit Skontoabzug",
    "discounted_price": "Diskontierter Preis",
    "net_amount": "Nettobetrag",
    "gross_amount": "Bruttobetrag",
    "total_amount_invoiced": "Rechnungsbetrag",
    "quarterly": "Quartalsweise",
    "quarterly_price": "Vierteljährlicher Preis",
    "net_quarterly_price": "Monatlicher Quartalspreis",
    "rating": "Bewertung",
    "recommendation": "Empfehlung",
    "recommendation_set": "Empfehlung hinterlegt",
    "recommendations": {
        "fine": "zu empfehlen",
        "blacklisted": "gesperrt"
    },
    "renewal_date": "Vertragserneuerungsdatum",
    "renewed_on": "Erneuert am",
    "cancellation_due_date": "Kündigungsdatum",
    "submission": "Eingereicht",
    "total_price": "Gesamtpreis",
    "total_cost": "Gesamtkosten",
    "renews_soon": "Erneuert sich bald",
    "request": "Antrag",
    "requests": "Anträge",
    "requested_by": "Beantragt von",
    "requester": "Antragssteller:in",
    "responsible_employee": "Verantwortliche Person",
    "shared_via_group_with": "Geteilt durch Gruppe mit",
    "shared_with": "Geteilt mit",
    "shared_people": "Mitarbeiter:innen",
    "review": "Prüfung",
    "role": "Rolle",
    "system_admin": "SysAdmin",
    "system": "System",
    "starting_date": "Startdatum",
    "status": "Status",
    "street_address": "Straße und Hausnummer",
    "subscription": "Abonnement",
    "superior": "Vorgesetzte",
    "superior_set": "Vorgesetzte:r gesetzt",
    "tax_number": "Steuernummer",
    "tax_set": "Steuernummer hinterlegt",
    "vat_set": "Umsatzsteuer-ID hinterlegt",
    "this_month": "Aktueller Monat",
    "this_quarter": "Aktuelles Quartal",
    "this_year": "Aktuelles Jahr",
    "tool_settings": "Allgemein",
    "upload_documents": "Dateien hochladen",
    "upload_documents_desc": "Nach dem Hochladen wird der/die Freigeber:in benachrichtigt.",
    "vat_number": "Umsatzsteuer-ID",
    "vendor": "Lieferant",
    "vendor_discount": {
        "discount": "Skonto",
        "days": "Tage",
        "days_one": "{{count}} Tag",
        "days_other": "{{count}} Tage"
    },
    "expense_discount": {
        "discount_info_1": "Skonto: ",
        "discount_info_2": "{{percentage}}% - Fällig am {{dueDate}} ",
        "discounted_due_date": "Fälligkeit Skonto",
        "discounted_total_gross": "Skonto angewandt: {{amount}}"
    },
    "derived_vendor": "Abgeleiteter Lieferant",
    "vendors": "Lieferanten",
    "work_phone": "Mobiltelefonnummer",
    "yearly_price": "Jährlicher Preis",
    "net_yearly_price": "Jährlicher Nettopreis",
    "yearly": "Jährlich",
    "zip": "PLZ",
    "country": "Land",
    "country_code": "Ländercode",
    "invoice_no": "Rechnungsnummer",
    "internal_invoice_no": "Eigenbelegnummer",
    "invoice_date": "Rechnungsdatum",
    "internal_invoice_date": "Eigenbelegdatum",
    "invoice_due_date": "Fällig am",
    "posting_period": "Buchungsperiode",
    "invoice_pdf_edited": "Bearbeitet",
    "invoice_pdf_original": "Original",
    "to_be_paid_at": "Zu bezahlen am",
    "to_be_paid": "Zu bezahlen",
    "to_be_exported": "Zu exportieren",
    "date_paid_at": "Bezahlt am",
    "recurring": "Abonnement",
    "renewal_expenses": "Wiederkehrende Abrechnungen",
    "recurring_expense": "Wiederkehrende Abrechnung",
    "billing_date": "Rechnungsdatum",
    "attached_expenses": "Beigefügte Ausgaben",
    "contracts": "Verträge",
    "vendor_contracts": "Rahmenverträge",
    "vendor_contract_set": "Vertrag hinzugefügt",
    "contract_document": "Vertragsdokument",
    "no_expenses_to_review": "Keine Ausgaben zu überprüfen.",
    "no_expenses_to_pay_or_export": "Keine Ausgaben zu bezahlen oder exportieren.",
    "no_expenses_to_export": "Keine Ausgaben zu exportieren.",
    "no_expenses": "Keine Ausgaben verfügbar.",
    "invoice_inbox": "Eingang",
    "to_dos": "To-dos",
    "in_progress": "In Bearbeitung",
    "pay": "Bezahlen",
    "pay_and_export": "Bezahlen & Exportieren",
    "export": "Exportieren",
    "done": "Erledigt",
    "exported": "Exportiert",
    "reviewed": "Geprüft",
    "paid": "Bezahlt",
    "item": "Artikel",
    "company_name": "Firmenname",
    "company": "Firma",
    "company_settings": "Firmeneinstellungen",
    "general": "Allgemein",
    "dashboard_and_workflows": "Dashboard & Workflows",
    "banking_and_cards": "Bank(en) & Karten",
    "export_and_bookkeeping": "Export & Buchhaltung",
    "companies": "Firmen",
    "transaction": "Transaktion",
    "transaction_container": {
        "inflow": "Zahlungseingang",
        "outflow": "Zahlungsausgang",
        "archive": "Archiv",
        "all": "Alle"
    },
    "transactions": "Transaktionen",
    "matched_transaction": "Gematchte Transaktion",
    "total": "Gesamtbetrag",
    "in_review": "In Prüfung",
    "processed": "Abgeschlossen",
    "in_payment": "In Zahlung",
    "in_export": "Zu exportieren",
    "matching": {
        "auto_matched": "Auto matched",
        "auto_unmatched": "Auto unmatched",
        "manually_matched": "Manuelle Übereinstimmung",
        "not_matched": "Nicht gematched",
        "request_to_create": "Antrag zum Erstellen",
        "manual_review": "Manuelle Prüfung",
        "no_matches": "Keine Übereinstimmungen gefunden.",
        "match_status": "Matching Status",
        "transaction_status": "Transaktionsstatus",
        "scheduled_for": "Geplant für {{date}}",
        "transaction_tag": {
            "pending": "Ausstehend",
            "completed": "Durchgeführt",
            "failed": "Fehlgeschlagen",
            "reversal": "Reversal"
        }
    },
    "configure": "Einstellungen",
    "recurring_subscription": "Abonnement",
    "budget_period": "Budget Intervall",
    "budget_period_type": {
        "monthly": "Monatsbudget",
        "quarterly": "Quartalsbudget",
        "yearly": "Jahresbudget"
    },
    "budget_currency": "Budget Währung",
    "bank_accounts": "Bankverbindungen",
    "bank_account": "Bankverbindung",
    "bank_account_filter": "Bankkkonto",
    "bank": "Bank",
    "default": "Standard",
    "bank_search_results": "Ergebnisse der Banken suche",
    "creditor_number": "Kreditorennummer",
    "default_creditor_number": "Standard Kreditorennummer",
    "default_employee_creditor_number": "Standard Mitarbeiter Kreditorennummer",
    "default_employee_language": "Standardsprache für Mitarbeiter:innen",
    "vat_unit": "MwSt. ({{unit}})",
    "vat": "MwSt.",
    "vat_title": "Mehrwertsteuer",
    "vat_total": "Summe MwSt.",
    "expense_accounts": "Sachkonten",
    "expense_account": "Sachkonto",
    "account_name": "Name",
    "account_code": "Code",
    "cost_centers_2": "Kostenträger",
    "cost_center_2": "Kostenträger",
    "cost_center_2_name": "Name",
    "cost_center_2_code": "ID",
    "purchased": "Leistungsdatum",
    "purchased_on": "Gekauft am",
    "selected": "Ausgewählt",
    "show_expense_numbers": "Nummerierung für Ausgaben anzeigen",
    "show_more": "Mehr anzeigen",
    "show_less": "Weniger anzeigen",
    "legend": "Legende",
    "options": "Optionen",
    "enable_ocr": "OCR",
    "enable_ocr_itemization": "OCR Artikel-Erkennung",
    "enable_email_notifications": "Email-Benachrichtigungen",
    "enable_go_to_next_expense": "Freigabe: Navigation zum nächsten Antrag",
    "show_gross": "Bruttobeträge anzeigen",
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "disable": "Deaktivieren",
    "card_number": "Kartennummer",
    "card": "Karte",
    "card_type": "Kartenart",
    "card_mode": "Modus",
    "card_holder": "Kartenhalter",
    "window": "Zeitintervall",
    "subscription_attached": "Subscription aktiv",
    "card_attached": "Karte hinterlegt",
    "balance": "Kontostand",
    "monthly_spending": "Monatliche Ausgaben",
    "expires_soon": "Läuft bald ab",
    "additional_interfaces": "Weitere Interfaces",
    "note": "Hinweis",
    "forecast": "Prognose",
    "none": "keine",
    "expense_type": "Kostenart",
    "min_amount": "Min Preis",
    "max_amount": "Max Preis",
    "min_budget": "Min Budget",
    "max_budget": "Max Budget",
    "min_limit": "Min limit",
    "max_limit": "Max limit",
    "min_creditor_number": "Min Kreditorennummer",
    "max_creditor_number": "Max Kreditorennummer",
    "min_date": "Min Datum",
    "max_date": "Max Datum",
    "period": "Zeitraum",
    "min_invoice_date": "Min Rechnungsdatum",
    "max_invoice_date": "Max Rechnungsdatum",
    "min_invoice_due_date": "Min Rechnungs Fälligkeitsdatum",
    "max_invoice_due_date": "Max Rechnungs Fälligkeitsdatum",
    "min_due_date": "Min Fälligkeitsdatum",
    "max_due_date": "Max Fälligkeitsdatum",
    "due_in_days": "Fällig in",
    "min_date_purchased": "Min Leistungsdatum",
    "max_date_purchased": "Max Leistungsdatum",
    "min_date_paid_at": "Min Bezahldatum",
    "max_date_paid_at": "Max Bezahldatum",
    "min_date_renewal": "Min Vertragserneuerungsdatum",
    "max_date_renewal": "Max Vertragserneuerungsdatum",
    "all_time": "Gesamtzeitraum",
    "all_times": "Bis heute",
    "current_year": "Dieses Jahr",
    "current_month": "Diesen Monat",
    "paused": "Pausiert",
    "active": "Aktiv",
    "paused_on": "Pausiert am",
    "resumed_on": "Reaktiviert am",
    "no_notifications": "Keine Benachrichtigungen.",
    "unread": "Ungelesene",
    "mark_all_as_read": "Alle gelesen markieren",
    "smart_cards": "Karten",
    "smart_card": "Karte",
    "smart_card_details": "Karten Details",
    "available_amount": "verfügbarer Betrag",
    "transaction_limit": "Transaktionslimit",
    "auto_recharge": "automatische Aufladung",
    "auto_recharge_trigger_amount": "automatische Aufladung bei",
    "low_balance_alert": "Benachrichtigung bei niedrigem Kontostand",
    "low_balance_alert_trigger_amount": "Warnwert bei niedrigem Kontostand",
    "reset_card_on": "Karte zurücksetzen am",
    "transaction_date": "Transaktionsdatum",
    "transaction_status": "Transaktionsstatus",
    "transaction_matched": "Matching Status",
    "matched_transaction_options": {
        "matched": "Matched",
        "not_matched": "Nicht matched"
    },
    "transaction_category": "Kategorie",
    "transaction_category_group": "Kategorie-Gruppe",
    "transaction_categorization_disabled": "Kategorisierung gesperrt",
    "connected_expense": "Verbundene Ausgabe",
    "Account": "Konto",
    "account": "Konto",
    "subject": "Verwendungszweck",
    "possible_expenses": "Mögliche Anträge",
    "matched_expenses": "Gematchte Anträge",
    "due_date": "Fällig am",
    "probability": "Wahrscheinlichkeit",
    "min_probability": "Min Wahrscheinlichkeit",
    "max_probability": "Max Wahrscheinlichkeit",
    "probability_short": "Wkt.",
    "transaction_to_be_matched": "Zu matchende Transaktion",
    "transaction_to_be_categorized": "Zu kategorisierende Transaktion",
    "type": "Art",
    "document_type": "Typ",
    "number": "Nummer",
    "connected_accounts": "Verbundene Konten",
    "transaction_details": "Transaktionsdetails",
    "transaction_type": "Transaktionsart",
    "transaction_source": "Quelle",
    "transaction_types": {
        "csv_transaction": "CSV Transaktion",
        "bank_transaction": "Banken Transaktion",
        "card_transaction": "Kartentransaktion",
        "funding_transaction": "Funding Transaktion",
        "outgoing_transaction": "Outgoing Transaktion",
        "internal_transfer": "Interne Transaktion"
    },
    "card_transaction_type": "Kartentransaktionskategorie",
    "bank_transaction": "Banktransaktion",
    "csv_transaction": "CSV Datei",
    "card_transaction": "Kartentransaktion",
    "security": "Sicherheitseinstellungen",
    "rules": "Regeln",
    "business_details": "Geschäftsdaten",
    "contact_details": "Kontakt",
    "tfa": {
        "authenticator": {
            "title": "Zwei-Faktor-Authentifizierung",
            "title_app": "Authenticator App",
            "title_sms": "SMS",
            "app_description": "Sie erhalten einen Login-Code über Google oder Duo Authenticator.",
            "sms_description": "Sie erhalten einen Login-Code via SMS.",
            "app_enabled": "App aktiviert",
            "sms_enabled": "SMS aktiviert",
            "notice": "Falls Ihr Admin für diese Firma Single Sign-On (SSO) aktiviert hat, dann wird bei einer Anmeldung, die per Google- oder Azure-Konto Login erfolgt, keine Zwei-Faktor-Authentifizierung berücksichtigt."
        },
        "setup": "Einrichten",
        "confirm_code": "Bestätigungscode eingeben",
        "confirm_code_description": "Bitte bestätigen Sie Ihr Konto, indem Sie den Authentifizierungscode eingeben, der an Ihre Google oder Duo Mobile Authenticator-App gesendet wurde oder den Sie per SMS erhalten haben.",
        "confirm_code_error": "Ungültiger oder abgelaufener Verifizierungscode",
        "setup_tfa_app_title": "Einrichtung über Drittanbieter-Authenticator",
        "setup_tfa_app_description": "Bitte verwenden Sie Ihre Authentifizierungsapplikation (z. B. Duo Mobile oder Google Authentifizierer), um diesen QR-Code zu scannen.",
        "setup_tfa_app_code": "Oder geben Sie diesen Code in Ihre Authentifizierungsapplikation ein",
        "reset_for_user": {
            "button": "Login-Einstellungen zurücksetzen"
        }
    },
    "no_icon_found_for_vendor": "Es wurde kein Icon für diesen Suchbegriff gefunden.",
    "no_budget_set": "Kein Budget definiert.",
    "login_error": {
        "remaining_attempt": "verbleibende Versuche, bevor Ihr Konto gesperrt wird",
        "error": "Fehler: Falsche oder ungültige Anmeldedaten",
        "account_blocked": "Fehler: Konto gesperrt",
        "retry_time": "Bitte versuchen Sie es erneut in"
    },
    "phone_verification": {
        "title": "Mobiltelefonnummer verifizieren",
        "number_description": "Wenn Sie Ihre Mobiltelefonnummer eingeben, erhalten Sie eine SMS mit einem Verifizierungscode",
        "code_description": "Geben Sie den Code ein, den Sie per SMS erhalten haben",
        "label": "Mobiltelefonnummer",
        "sms_request_error": "Für diese Nummer konnte kein Verifizierungscode gesendet werden. Bitte versuchen Sie es später noch einmal",
        "invalid_code": "Ungültiger oder abgelaufener Verifizierungscode",
        "verified": "Verifiziert",
        "duplicate_work_phone": "Diese Mobiltelefonnummer existiert bereits."
    },
    "notifications": {
        "most_recent": "Aktuellste",
        "older": "Ältere",
        "title": "Benachrichtigungen",
        "email_settings": "Allgemeine Email-Benachrichtigungen",
        "bundle": {
            "title": "bündeln",
            "off": "Aus",
            "daily": "Täglich",
            "weekly": "Wöchentlich",
            "yearly": "Jährlich"
        },
        "enable_all_notifications": {
            "title": "Alle Benachrichtigungen",
            "description": "Mit dieser Einstellung erhalten Sie alle Benachrichtigungen."
        },
        "enable_comments_mentions": {
            "title": "Kommentare & @-Erwähnungen",
            "description": "Erhalten Sie nur dann Benachrichtigungen, wenn Sie direkt oder in Kommentaren erwähnt werden.",
            "tooltip": "Kommentare in Ihren Anträgen @-Erwähnungen"
        },
        "enable_action_to_call": {
            "title": "Benachrichtigungen mit Handlungsaufforderung",
            "description": "Erhalten Sie Benachrichtigungen, wenn Sie konkret zu einer Handlung in finway aufgefordert werden, z. B. wenn Sie eine Rechnung hochladen müssen.",
            "tooltip": "Freigabe benötigt, Rechnung benötigt, Abonnement-Verlängerung, Zahlung fällig"
        },
        "enable_my_action": {
            "title": "Benachrichtigungen zu Ihren Aktionen",
            "description": "Erhalten Sie Benachrichtigungen zu Updates, die Ihre Aktionen in finway betreffen, z. B. Ihre Anträge, Abonnements oder von Ihnen erstellte Lieferanten.",
            "tooltip": "Ihre Kostenstelle, Ihre Anträge, Ihre Lieferanten, Ihre Abonnements, Ihre Karten"
        },
        "ownCardTransactionAlert": {
            "title": "Benachrichtigungen zu Ihren eigenen Kartentransaktionen",
            "description": "Sie erhalten aktuelle Informationen über den Status Ihrer Kartentransaktion, z. B. ob die Kartentransaktion noch aussteht oder erfolgreich war."
        },
        "informative": {
            "title": "Informative Benachrichtigungen",
            "description": "Erhalten Sie zusätzlich Benachrichtigungen, die nicht direkt mit Ihren Aktionen zusammenhängen, z. B. ein neuer Lieferant wurde angelegt, ein neuer Antrag wurde erstellt.",
            "tooltip": "Rechnungen, Unternehmen, Bankkonten, Mitarbeiter:innen, Kostenstellen, Workflows, Anträge, Lieferanten, Abonnements, Karten, Kostenträger"
        },
        "advanced_notification": "Erweiterte Einstellungen",
        "auto_invoice_missing_reminder": "Automatische Erinnerung an fehlende Rechnungen jeden Monat senden am",
        "recurring_invoice_missing_reminder": "Automatisch wöchentliche Erinnerungen an fehlende Rechnungen senden nach (Tagen)",
        "received_money_wallet": "Benachrichtigung, wenn Geld auf Ihrem finway-Wallet eingegangen ist.",
        "wallet_balance": "Benachrichtigung, wenn Wallet-Guthaben kleiner als",
        "wallet_balance_tooltip": "Erhalten Sie eine E-Mail, wenn das Wallet-Guthaben unter dem von Ihnen definierten Wert liegt. Bitte geben Sie nur positive Werte ein.",
        "wallet_balance_negative_amount_warning": "Bitte nur positive Werte eintragen",
        "costcenter_spent_budget": "Benachrichtigung, wenn 80 % eines Kostenstellen-Budgets ausgegeben wurden.",
        "card_transaction_status": "Benachrichtigungen zu erfolgreichen oder abgelehnten Kartentransaktionen",
        "card_transaction_status_tooltip": "Sie erhalten eine E-Mail für jede getätigte Kartentransaktion innerhalb Ihrer Firma.",
        "general_notification": "Unternehmensweite Benachrichtigungen",
        "pending_transactions_alert": "Neue Banktransaktion im Status Pending für mehr als 10 Tage",
        "pending_transactions_alert_tooltip": "Wenn diese Benutzer-basierte Einstellung aktiviert ist, wird eine E-Mail verschickt, wenn eine neue Banktransaktion länger als 10 Tage im Status Pending ist. In diesen Fällen kann die jeweilige Bank weitere Einzelheiten mitteilen. Diese E-Mail-Benachrichtigung kann nicht gebündelt werden.",
        "all_notifications": "Das sind all Ihre Benachrichtigungen der letzten Woche."
    },
    "found_icons": "Bitte wählen Sie eines der gefunden Icons aus",
    "modal_footer": {
        "continue": "Weiter",
        "return": "Zurück",
        "cancel": "Abbrechen"
    },
    "expense_document": {
        "new_document": "Neues Dokument",
        "invoice": "Rechnung",
        "delivery_note": "Lieferschein",
        "offer": "Angebot"
    },
    "date": "Datum",
    "spendings": "Ausgaben",
    "bank_transfer": "Banküberweisung",
    "cards": {
        "card_name": "Kartenname",
        "virtual": "virtuelle",
        "physical": "physische",
        "created_at": "Erstellt am",
        "card": "Karte",
        "credit_cards": "Karten",
        "tag": {
            "ordered": "Bestellt",
            "active": "Aktiv",
            "suspended": "Deaktiviert",
            "terminated": "Gesperrt",
            "reported_stolen": "Gestohlen gemeldet",
            "reported_lost": "Verloren gemeldet",
            "error": "Error"
        },
        "card_type": "Kartentyp",
        "frequency": "Zeitintervall",
        "amount_limit": "Limit je Zeitintervall",
        "usage_limit": "Transaktionslimit",
        "available_balance": "Verfügbare Balance",
        "spendings": "Ausgaben",
        "atm_withdrawals": "Geldautomatenentnahmen",
        "cashback_enabled": "Cashback aktiviert",
        "auto_recharge_enabled": "Automatische Aufladung",
        "enabled": "Aktiviert",
        "disabled": "Deaktiviert",
        "window": {
            "day": "Täglich",
            "daily": "Täglich",
            "week": "Wöchentlich",
            "weekly": "Wöchentlich",
            "month": "Monatlich",
            "monthly": "Monatlich",
            "life_time": "Lebenslang",
            "lifetime": "Lebenslang",
            "transaction": "Einmalig",
            "one_time": "Einmalig",
            "quarterly": "Quartalsweise",
            "quarter": "Quartalsweise",
            "yearly": "Jährlich",
            "year": "Jährlich"
        },
        "bank_transfer": "Banküberweisung",
        "subscriptions": {
            "available_amount_per_card": "Verfügbarer Betrag per Karte",
            "switch_to_finway_cards": "Mit finway-Karten können Sie Ihre Abonnementzahlungen einfach automatisieren.",
            "issue_card_requester_not_enrolled": "Der Abonnementantragsteller ist nicht Teil des Kartenprogramms, daher kann keine Karte ausgestellt werden.",
            "issue_card_requester_not_enrolled_please_contact": "Bitte kontaktieren Sie {{name}}."
        },
        "waiting_for_card_transaction": {
            "title": "Wartend auf Kartentransaktion",
            "message": "Sobald wir die Kartentransaktion erhalten, wird dieser Antrag aktualisiert."
        },
        "virtual_card": "Virtuelle Karte",
        "attached_subscription": "Verbundenes Abonnement",
        "attached_expense": "Verbundener Antrag",
        "attached_purchase_order": "Verbundener Einkaufsantrag",
        "activation_code": {
            "title": "Aktivierung der Karte",
            "description_title": "Aktivierungscode",
            "message": "Bitte geben Sie den Aktivierungscode für diese Karte ein. Ihr Aktivierungscode wurde per Email an Sie versandt, als Sie die Karte erstellt haben."
        },
        "card_program": "Kartenprogramm",
        "is_enrolled": "Registriert",
        "not_enrolled": "Nicht registriert",
        "transaction_types": {
            "authorised": "Autorisiert",
            "declined": "Abgelehnt",
            "cancelled": "Storniert",
            "online_reverse": "Online Rückerstattung",
            "manual_close": "Manuell geschlossen",
            "authorised_credit": "Kredit autorisiert",
            "sale_purchase": "Einkauf",
            "cash_withdrawal": "Barabhebung",
            "sale_with_cashback": "Verkauf mit Cashback",
            "mail_or_telephone_order": "Post- oder Telefonbestellung",
            "purchase_refund_reversal": "Rückbuchung von Kauferstattungen",
            "original_credit_transaction_reversal": "Stornierung der ursprünglichen Transaktion",
            "cash_withdrawal_reversal": "Stornierung einer Bargeldentnahme",
            "purchase_refund": "Kauferstattung",
            "purchase_reversal": "Kaufstornierung",
            "original_credit_transaction": "Ursprüngliche Transaktion",
            "first_chargeback": "Erste Rückbuchung",
            "first_chargeback_reversal": "Erste Rückbuchung storniert",
            "first_representment": "Erste Vertretung",
            "first_representment_reversal": "Erste Vertretungsumstellung",
            "second_chargeback": "Zweite Rückbuchung",
            "second_chargeback_reversal": "Zweite Rückbuchung storniert",
            "second_representment": "Zweite Stellvertretung",
            "arbitration_chargeback": "Rückbuchung",
            "balance_inquiry": "Saldo-abfrage",
            "expired": "Abgelaufen"
        },
        "decline_reasons": {
            "physical_not_activated": "Physische Karte nicht aktiviert",
            "insufficient_balance": "Guthaben zu niedrig",
            "cvv_checks_failed": "CVV-Prüfungen sind fehlgeschlagen",
            "cvv_retries_exceeded": "CVV-Wiederholungsversuche überschritten",
            "card_status_not_allowed": "Kartenstatus ist nicht zulässig",
            "pin_checks_failed": "Die PIN-Prüfung ist fehlgeschlagen",
            "pin_retries_exceeded": "Anzahl der PIN-Wiederholungsversuche überschritten",
            "card_expiry_checks_failed": "Die Überprüfung des Gültigkeitsdatums der Karte ist fehlgeschlagen",
            "avs_checks_failed": "Überprüfung der Adresse ist fehlgeschlagen",
            "atm_withdrawal_limit_exceeded": "Limit für Abhebungen am Geldautomaten überschritten",
            "sca_required": "Erweiterte Kundenauthentifizierung erforderlich",
            "auth_rule_checks_failed": "Prüfungen der Authentifizierungsregel sind fehlgeschlagen",
            "transaction_not_permitted": "Transaktion nicht erlaubt.",
            "no_reason": "Kein Grund",
            "timeout": "Zeitüberschreitung",
            "owt_sent_successfully_but_refused_by_beneficiary_bank": "Bankablehnung. Die Transaktion wurde von der angegebenen Empfängerbank abgelehnt und zurückgegeben."
        },
        "mode": {
            "mode": "Kartenart",
            "prepaid_mode": "Prepaid",
            "debit_mode": "Debit"
        },
        "current_card_limit": "Aktuelles Kartenlimit",
        "type": {
            "physical": "Physisch",
            "virtual": "Virtuell"
        },
        "delivery_type": {
            "title": "Zustellungsmethode",
            "standard_delivery": "Standard",
            "registered_mail": "Per Einschreiben",
            "courier": "Kurier",
            "first_class_mail": "First Class Mail"
        },
        "update_expense_amount_on_card_transaction": "Automatisch Antragsbeträge anpassen",
        "card_program_auth": "Kartenprogramm-Authentifizierung",
        "card_program_strong_auth": "Erweiterte Kartenprogramm-Authentifizierung",
        "bin": "BIN",
        "enrollment_not_eligible": "Nicht berechtigt",
        "issued_by": "Issued by {{bank}} pursuant to license by {{network}}."
    },
    "attached_card": "Verbundene Karte",
    "limit": "Limit",
    "monthly_statement": "Monatliche Aufstellung",
    "purchase_data": "Antragsdetails",
    "vendor_data": "Lieferantendetails",
    "set_vendor_rule": "Lieferanten-Regeln definieren",
    "vendor_rule": "Lieferantenregel",
    "payment_term": "Zahlungsfrist",
    "payment_term_desc": "Zahlungsfrist (Tage)",
    "wallet": {
        "wallet_details": "Wallet Details",
        "amount_to_be_transferred": "Zu überweisender Betrag",
        "transfer_from": "Überweisung von",
        "verification_of_payee": {
            "provided_name": "Von Ihnen angegebener Name",
            "registered_name": "Registrierter Kontoname",
            "result": {
                "MATCH": "Übereinstimmung",
                "CLOSE_MATCH": "Fast identisch",
                "NO_MATCH": "Keine Übereinstimmung",
                "NOT_POSSIBLE": "Überprüfung nicht möglich"
            }
        }
    },
    "corporate": {
        "business_address": "Geschäftsadresse"
    },
    "payment_pending": {
        "message": "Die Zahlung ist in Bearbeitung",
        "description": "Bitte starten Sie eine neue Zahlung nur, wenn Ihre vorherige Zahlung im Zahlungsformular nicht erfolgreich abgeschlossen wurde. Wenn Sie den Zahlungsvorgang erfolgreich abgeschlossen haben, starten Sie bitte keinen neuen Zahlungsversuch. Einige Banken übermitteln den Zahlungsstatus zeitverzögert. Es kann daher bis zu 5 Tage dauern, bis der Zahlungsstatus aktualisiert wird.",
        "tag": "Transaktion ausstehend"
    },
    "payment_successful_transaction_pending": {
        "message": "Die Zahlung ist erfolgreich, aber die Transaktion ist noch ausstehend.",
        "description": "Bitte aktualisieren Sie den Status der Transaktion oder setzen Sie die Zahlung für diesen Antrag zurück.",
        "tag": "Zahlung ausstehend"
    },
    "vat_rate": "MwSt.-Satz",
    "bu_code": "BU Nummer",
    "bu_code_name": "BU Codename",
    "teams": "Abteilungen",
    "team_users": "Nutzer:innen in Abteilung",
    "team": "Abteilung",
    "schedule_payment": "Terminüberweisung planen",
    "direct_payment": "Bezahlung in Echtzeit",
    "subject_line": "Betreffzeile für Ausgabe #{{expenseNumber}} ({{receiver}})",
    "workflows": "Workflows",
    "all": "Alle",
    "workflow": {
        "workflow": "Workflow",
        "workflow_type": {
            "title": "Workflowtyp",
            "request": "Antrag",
            "folder": "Reise"
        },
        "scope": {
            "all": "Alle Anträge",
            "purchase": "Einkaufsanträge",
            "invoice": "Rechnungsanträge",
            "reimbursement": "Rückerstattungsanträge",
            "scope": "Gültigkeit"
        },
        "request_type": {
            "title": "Antragstyp",
            "all": "Alles",
            "purchase": "Abonnement / Kaufantrag",
            "subscription": "Abonnement",
            "invoice": "Rechnungsantrag",
            "all_reimbursements": "Alle Erstattungen",
            "standard_reimbursement": "Standarderstattung",
            "reimbursement": "Rückerstattung",
            "hospitality_reimbursement": "Bewirtungserstattung",
            "mileage_reimbursement": "Kilometerpauschale",
            "per_diem_reimbursement": "Verpflegungsmehraufwand",
            "trip_folder": "Reise",
            "purchase_order": "Bestellungen"
        },
        "trigger": {
            "trigger": "Auslöser",
            "trigger_type": "Auslösetyp",
            "trigger_objects": "Auslösen",
            "requester": "Antragsteller:in",
            "vendor": "Lieferant",
            "cost_center": "Kostenstelle",
            "cost_center_2": "Kostenträger",
            "expense_account": "Sachkonto",
            "net_amount": "Netto-Betrag",
            "all": "Alle"
        },
        "types_amount": "{{amount}} Typen",
        "approver": "Genehmiger:in",
        "multiple_approvers": "Mehrere Genehmiger:innen",
        "condition": {
            "amount": "Bedingung (Betrag {{comparison}} {{amount}})",
            "then": "dann"
        },
        "operator": {
            "and": "und",
            "or": "oder"
        }
    },
    "omit_special_character": "Sonderzeichen können weggelassen werden.",
    "transaction_data": "Transaktionsdetails",
    "payment_data_added": "Zahlungsdaten hinterlegt",
    "integrations": "Integrationen",
    "active_sessions": "Aktive Sitzungen",
    "devices": "Geräte",
    "login": "Login",
    "datev": "DATEV",
    "datev_csv": "DATEV CSV",
    "datev_invoice_csv": "DATEV Beleg CSV",
    "datev_settings": "DATEV Einstellungen",
    "datev_online": "DATEV Unternehmen Online (DUO)",
    "follow_up_info": "Bitte wählen Sie ein Datum, an dem Sie erinnert werden möchten",
    "cost_center_group": "Kostenstellengruppe",
    "parent_cost_center": "Übergeordnete Kostenstelle",
    "individual_cost_center": "Kostenstelle",
    "sub_cost_center": "Unterkostenstelle von",
    "not_set": "Nicht eingestellt",
    "split_noun": "Aufteilung",
    "split": "Teilen",
    "split_net": "Netto-Split",
    "splitted": "Aufgeteilt",
    "month": "Monat",
    "quarter": "Quartal",
    "year": "Jahr",
    "enter_date_of_birth": "Geburtsdatum eintragen",
    "months": "Monate",
    "quarters": "Viertel",
    "years": "Jahre",
    "select_dates": "Daten auswählen",
    "last_&_upcoming_months": "Vergangene und/oder kommende Monate",
    "viewing_period": "Betrachtungszeitraum",
    "monthly_view": "Monatsansicht",
    "quarterly_view": "Quartalsansicht",
    "yearly_view": "Jahresansicht",
    "expenses_paid": "Bezahlte Ausgaben",
    "expenses_pending": "Ausstehende Rechnungen",
    "purchase_orders_pending": "Ausstehende Bestellungen",
    "performance_period": "Leistungszeitraum",
    "performance_period_start_date": "Beginn des Leistungszeitraums",
    "performance_period_end_date": "Ende des Leistungszeitraums",
    "performance_date": "Leistungsdatum",
    "budget_left": "Restbudget",
    "deleted": "Gelöscht",
    "spending_within_budget": "Ausgaben im Budget",
    "spending_forecast_within_budget": "Prognostizierte Ausgaben innerhalb des Budgets",
    "spending_above_budget": "Ausgaben über dem Budget",
    "spending_forecast_above_budget": "Prognostizierte Ausgaben über dem Budget",
    "transfer": "Wallet Transfer",
    "auto_matching_feature": "Automat. Matching von Transaktionen",
    "invoice_auto_matching_feature": "Automat. Matching von Inbox Rechnungen",
    "allow_cost_center_2_creation": "Kostenträger Erstellung erlauben",
    "is_lexware_export_enabled": "Lexware CSV Export",
    "is_non_sepa_xml_export_enabled": "NON SEPA XML Export",
    "is_sepa_xml_bulgaria_enabled": "SEPA XML (Bulgarien)",
    "potential_duplicate": "Potenzielles Duplikat",
    "new_vendor": "Neuer Lieferant",
    "potential_duplicate_vendors": "Potenzielle Duplikate",
    "steps": "Schritte",
    "no_match_found": "Keine Übereinstimmung gefunden.",
    "consultant_number": "Berater #",
    "client_number": "Mandat #",
    "skipped": " (Übersprungen)",
    "allow_workflow_adjustments": "Workflow-Anpassungen erlauben",
    "tagging_feature_enable": "Tagging-Funktion aktivieren",
    "editing_tags_enable": "Tagging-Funktion: Schreibrechte für alle erlauben",
    "employee_labels": {
        "mileage_rate": "Individueller Kilometersatz"
    },
    "employee_absence": {
        "absent": "Abwesend",
        "absence": "Abwesenheit",
        "title": "Abwesende:r Genehmiger:in",
        "description": "Genehmiger:in {{name}} ist bis zum {{date}} abwesend. Möchten Sie warten bis er/sie zurückkommt? Wenn Ihr Antrag dringend ist, können Sie eine:n andere:n Genehmiger:in auswählen",
        "approver_absent_until": "{{name}} ist bis {{date}} abwesend",
        "wait_for_return": "Kann das bis zur Rückkehr warten? Wenn Ihr Antrag dringend ist, können Sie eine:n andere:n Genehmiger:in auswählen",
        "back_in": "Zurück in",
        "day": "{{count}} Tag",
        "day_other": "{{count}} Tagen",
        "purchase_request_hint": " (gilt für Einkaufs- & Rechnungsfreigabe)",
        "substitute_for_approval": "Vertretung für Genehmigungen"
    },
    "liquidity": {
        "tabs": {
            "cashflow": "Cashflow-Planung",
            "dashboard": "Dashboard",
            "transaction_categories": "Kategorisierung"
        },
        "cash_forecast": "Liquidität und Prognose",
        "forecast": "Prognose",
        "actual": "Aktuell",
        "plan": "Prognose",
        "compared_to_plan": "gegenüber der Prognose",
        "rule_based_value": "planungs-regel basiert",
        "manually_added_value": "manuell hinzugefügt",
        "scenario": {
            "create": "Neues Szenario erstellen",
            "edit": "Szenario bearbeiten"
        },
        "forecast_rule": {
            "type": "Typ",
            "description": "Beschreibung",
            "amount": "Betrag",
            "category": "Kategorie",
            "tabs": {
                "cashflow_planning": "Transaktionen planen",
                "planned_cashflow": "Geplante Transaktionen verwalten"
            }
        },
        "cash_balance": "Geld-Bestand",
        "cashflow_cumulated": "Cashflow kumuliert",
        "month_over_month": "MoM",
        "this_month": "Aktueller Monat",
        "this_year": "Aktuelles Jahr",
        "cash_inflow": "Zahlungseingänge",
        "cash_outflow": "Zahlungsausgänge",
        "cash_actual_vs_forecast": "Liquidität: Soll-/Ist-Vergleich",
        "cash_in_all_bank_accounts": "Geld-Bestand - Veränderung",
        "overall_expenses_by_main_categories": "Ihre Ausgaben nach Kategorie",
        "total_spending_compared_to_plan": "Gesamtausgaben im Vergleich zu Ihrer Prognose",
        "vs_plan": "vs. Prognose",
        "return": "Zurück zum Liquiditäts-Dashboard",
        "actual_spending": "Zahlungsausgänge (tatsächlich)",
        "forecast_spending": "Zahlungsausgänge (Prognose)",
        "cash_in_actual": "Zahlungseingänge (tatsächlich)",
        "cash_out_actual": "Zahlungsausgänge (tatsächlich)",
        "cash_in_forecast": "Zahlungseingänge (Prognose)",
        "cash_out_forecast": "Zahlungsausgänge (Prognose)",
        "balance": "Geld-Bestand",
        "bank_name": "Bankname",
        "account_name": "Kontoname",
        "forecast_conflict_warning": "Ihre manuelle Eingabe widerspricht Ihren Angaben durch Regeln",
        "forecast_conflict_tooltip_message": "Ihre regelbasierte Eingabe (<0 />) wurde manuell überschrieben. Für ein Reset, geben Sie bitte die regel-basierte Eingabe manuell ein.",
        "directly_allocated_to_parent_category": "Direkt zugeordnet zu {{categoryName}}: <0 />.",
        "actual_spending_vs_forecast": "Zahlungsausgänge gegenüber Prognose: "
    },
    "refund": "Erstattung",
    "credit_note": "Gutschrift",
    "address": "Adresse",
    "address_line": "Straßenname und -nummer",
    "delivery_address": "Lieferadresse",
    "business_address": "Geschäftsadresse",
    "same_as_business_address": "Gleiche Adresse wie Geschäftsadresse.",
    "features": "Features",
    "phone_number": "Mobiltelefonnummer",
    "missing_invoices": "Fehlende Rechnung",
    "missing_invoices_desc": "Sie können dem/der Antragsteller:in eine Erinnerung senden.",
    "troubleshooting": "Fehlerbehebung",
    "bulk_data_upload": "Daten-Upload",
    "tool_settings_security": "Tool-Einstellungen & Sicherheit",
    "feature_settings": "Feature-Einstellungen",
    "timezone": "Zeitzone",
    "payment_settings": {
        "title": "Abonnement & Zahlung",
        "plan": "finway-Abonnement",
        "payment": "Zahlungsmethode",
        "invoices": "Rechnungen",
        "usage_consumption": "Anträge",
        "intervals": {
            "monthly": "Monatlich",
            "yearly": "Jährlich"
        },
        "per_card_interval": {
            "monthly": "pro Monat",
            "yearly": "pro Jahr"
        },
        "discount": "Rabatt",
        "discount_until": "gültig bis",
        "already_paid": "Bereits bezahlt",
        "per_card": "pro Karte",
        "billing_plan": "Zahlungsplan",
        "billing_period": "Zahlungszeitraum",
        "billing_plans_missing": "Noch offen...bitte schauen Sie später vorbei!",
        "physical_cards": "Physische Karten",
        "card_prices_title": "Kartenpreise",
        "card_prices_number": "Karten",
        "card_prices_monthly": "Monatlich",
        "card_prices_yearly": "Jährlich",
        "enterprise": "Enterprise",
        "trial": "Probezeit",
        "trial_upgrade_header": "Upgraden Sie Ihr Paket",
        "trial_upgrade_message": "Beantragen Sie vollen Zugriff, um Ihre Finanzprozesse abzudecken.",
        "payment_method_type": "Zahlungsmethode",
        "card_payment": "Kartenzahlung",
        "sepa_direct_debit": "SEPA direct debit",
        "card_number": "Kartennummer",
        "expiration_date": "Ablaufdatum",
        "cvc": "CVC",
        "email": "Email",
        "second_email": "Zweite Email",
        "Name": "Name",
        "iban": "IBAN",
        "invoice_address": "SEPA - Rechnungsadresse",
        "second_address": "2. Adresszeile",
        "postcode": "Postleitzahl",
        "city": "Stadt",
        "country": "Ländercode (zwei Buchstaben, z.B. DE)",
        "invoice_no": "Rechnungsnummer"
    },
    "archive": "Archiv",
    "reason_of_the_request": "Grund der Anfrage",
    "no_reason": "Kein Grund",
    "inflow": "Zahlungseingang",
    "outflow": "Zahlungsausgang",
    "parent_transaction_category": "Übergeordnete Transaktionskategorie",
    "categories": "Kategorien",
    "vendor_creation_for_all": "Lieferantenerstellung durch alle Nutzer:innen",
    "add_audit_trail_to_invoice_export": "Audit-Protokoll wird als zusätzliche Datei generiert",
    "archiveExpensesAfterXDays": "Ausgaben automatisch archivieren nach",
    "archiveTransactionsAfterXDays": "Transaktionen automatisch archivieren nach",
    "archived": "Archiviert",
    "manually_unarchived": "Manuell ausarchiviert",
    "days": "Tage",
    "user_integrations": "Benutzerweite Integrationen",
    "company_integrations": "Firmenweite Integrationen",
    "get_my_invoices": "GetMyInvoices",
    "user_id": "Benutzer:in",
    "min_upload_date": "Min Hochladedatum",
    "max_upload_date": "Max Hochladedatum",
    "uploaded_by": "Hochgeladen von",
    "vendor_name": "Lieferant",
    "simulator": "Simulator",
    "csv_delimiter": "CSV-Trennzeichen",
    "csv_delimiter_type": {
        "comma": "Komma {,}",
        "semicolon": "Strichpunkt {;}"
    },
    "number_separator": "CSV-Dezimaltrennzeichen",
    "number_separator_type": {
        "comma": "Komma {,}",
        "dot": "Punkt {.}"
    },
    "export_format": {
        "title": "Export Format",
        "csv": "Exportiert als CSV",
        "not_csv": "Nicht exportiert als CSV",
        "datev_xml": "Exportiert als DATEV XML",
        "not_datev_xml": "Nicht exportiert als DATEV XML",
        "datev_invoice_csv": "Exportiert als DATEV Beleg CSV",
        "not_datev_invoice_csv": "Nicht exportiert als DATEV Beleg CSV",
        "datev_online": "Exportiert nach DUO",
        "not_datev_online": "Nicht exportiert nach DUO",
        "all_datev": "Exportiert nach DUO oder DATEV XML",
        "not_all_datev": "Nicht exportiert nach DUO und DATEV XML"
    },
    "debtor": "Debitor",
    "derived_debtor": "Abgeleiteter Debitor",
    "upgrade": "Upgrade",
    "get_free_demo": "Zur kostenfreien Demo",
    "being_exported_to_duo": "Wird gerade zu DUO exportiert",
    "export_to_duo_failed": "DUO Exportfehler",
    "custom": {
        "for_you": "für Sie",
        "for_user": "für Benutzer:in {{userName}}"
    },
    "language": "Sprache",
    "german": "Deutsch",
    "english": "Englisch",
    "date_due_in_badge": {
        "in_x_days": "in {{numberOfDays}} Tagen",
        "overdue": "überfällig",
        "due_today": "heute fällig",
        "due_tomorrow": "morgen fällig"
    },
    "reimbursement_type": "Rückerstattungs-Typ",
    "reimbursement_types": {
        "standard": "Standard",
        "standard_reimbursement": "Rückerstattung",
        "mileage": "Fahrtkosten",
        "hospitality": "Bewirtung",
        "per_diem": "Verpflegungsmehraufwand"
    },
    "expense_types": {
        "standard_reimbursement": "Rückerstattung",
        "mileage_reimbursement": "Kilometerpauschalen-Erstattung",
        "per_diem_reimbursement": "Verpflegungsmehraufwands-Erstattung",
        "hospitality_reimbursement": "Bewirtungs-Erstattung",
        "invoice_request": "Rechnungsantrag"
    },
    "mileage": {
        "reason": "Beschreibung/Anlass der Fahrt",
        "return_type": "Einfache Fahrt/Rückfahrt",
        "date": "Datum der Fahrt",
        "invoice_date": "Eigenbelegdatum",
        "return_date": "Datum der Rückfahrt",
        "distance": "Entfernung",
        "duration": "Dauer",
        "vehicle": "Transportmittel",
        "amount": "Erstattbarer Gesamtbetrag",
        "billable": "Weiterverrechenbar",
        "start_address": "Startadresse",
        "destination_address": "Zieladresse",
        "reimbursable": "Erstattungsfähig",
        "vehicle_type": {
            "car": "Auto",
            "motorcycle": "Motorrad"
        },
        "trip_information": "Reise-Informationen",
        "one_way": "Einweg",
        "return": "Rückfahrt/Rundfahrt",
        "distance_buffer": "Fahrtkostenerstattung Entfernungspuffer",
        "setup": "Einstellen",
        "summary": "Übersicht",
        "map": "Karte",
        "additional_distance_reason": "Grund für die zusätzliche Entfernung",
        "stops": "Stops",
        "x_stops": "{{count}} Stops"
    },
    "hospitality": {
        "merchant": "Bewirtungsstätte",
        "tip": "Trinkgeld",
        "date": "Datum der Bewirtung",
        "attendees": "Teilnehmer:innen",
        "reason": "Beschreibung/Anlass der Bewirtung",
        "beverages": "Speisen / Getränke"
    },
    "per_diem": {
        "half_day_start": "Halbtagespauschale",
        "half_day_return": "Halbtagespauschale",
        "full_day": "Tagespauschale",
        "breakfast": "Frühstück",
        "lunch": "Mittagessen",
        "dinner": "Abendessen",
        "accommodation": "Unterkunft",
        "reimbursement": "Erstattung",
        "day": "Tag",
        "allowance": "Pauschbetrag",
        "reason": "Beschreibung/Anlass der Dienstreise",
        "destination": "Hauptziel (Stadt)",
        "start_date": "Startdatum",
        "end_date": "Enddatum",
        "time": "Zeit",
        "billable": "abrechnungsfähig",
        "amount": "Erstattungsfähiger Gesamtbetrag",
        "transfer_date": "Übertragungsdatum",
        "additional_destinations": "Weitere(n) Zielort(e)"
    },
    "folder": {
        "description": "Beschreibung/Anlass der Reise",
        "main_destination": "Hauptzielort (Stadt)",
        "start_date": "Startdatum",
        "trip_start_date": "Startdatum",
        "time": "Zeit",
        "return_date": "Rückkehrdatum",
        "total": "Reisegesamtbetrag",
        "folder": "Reise",
        "details": "Reise",
        "trip_folder_details": "Details zur Reise",
        "submitted_on": "Eingereicht am",
        "summary": "Übersicht"
    },
    "pdf_viewer": {
        "match_case": "Groß- und Kleinschreibung beachten",
        "whole_words": "Vollständige Wörter",
        "previous_match": "Letzter Treffer",
        "next_match": "Nächster Treffer",
        "close": "Schließen"
    },
    "roles": {
        "title": "Rollen",
        "global_rights": "Globale Rechte",
        "standard_rights": "Standard Rechte",
        "detailed_rights": "Detaillierte Rechte",
        "resource": "Funktion",
        "access_rights": "Sichtrecht",
        "action_rights": "Bearbeitungsrecht",
        "default_menu_info": "Die Bereiche $t(nav:dashboard), $t(nav:subscriptions), $t(nav:credit_card), $t(nav:cost_centers) und $t(nav:employees) sind für alle Nutzer:innen sichtbar."
    },
    "rights": {
        "resource": {
            "requests": "Anträge",
            "formal_review": "Formelle Prüfung",
            "pay": "Zahlungen",
            "export": "Export",
            "subscriptions": "Abonnements",
            "cards": "Karten",
            "transactions": "Transaktionen",
            "employees": "Mitarbeiter:innen",
            "cost_centers": "Kostenstellen",
            "vendors": "Lieferanten",
            "workflows": "Workflows",
            "liquidity": "Liquidität",
            "reporting": "Reporting",
            "global_insights": "Globale Insights",
            "settings": "Einstellungen",
            "procurement": "Einkauf"
        },
        "global_no_editing_rights": {
            "title": "Keine Bearbeitungsrechte",
            "tooltip": "Entzieht der Rolle jegliche Bearbeitungsrechte."
        },
        "global_viewing_right": {
            "title": "Einsichtsrecht",
            "tooltip": "Berechtigt zum Einsehen jeglicher Daten innerhalb des Unternehmens.",
            "gobd_tooltip": "Berechtigt zum Einsehen jeglicher Daten innerhalb des Unternehmens und zum Export des Änderungsprotokolls."
        },
        "global_inbox_invoices": {
            "title": "Eingang Management",
            "tooltip": "Berechtigt zum Einsehen und Zuweisen aller hochgeladenen Dokumente im Eingang"
        },
        "global_request_on_others_behalf": {
            "title": "Anträge im Namen anderer Nutzer:innen erstellen",
            "tooltip": "Berechtigt im Namen anderer Mitarbeiter:innen Anträge zu erstellen."
        },
        "global_selectable_as_approver": {
            "title": "Wählbar als Genehmiger:in in Anträgen & Workflows"
        },
        "standard_upload_invoices": {
            "title": "Rechnungen hochladen"
        },
        "standard_create_expenses": {
            "title": "Anträge erstellen"
        },
        "standard_suggest_vendors": {
            "title": "Lieferanten vorschlagen",
            "tooltip": "Während der Antragserstellung können Lieferanten vorgeschlagen werden."
        },
        "approval_viewingright1": {
            "tooltip": "Sichtrecht für alle Anträge innerhalb des Unternehmens."
        },
        "approval_viewingright2": {
            "tooltip": "Sichtrecht für alle Abteilungsanträge innerhalb des Unternehmens."
        },
        "review_viewingright1": {
            "tooltip": "Sichtrecht für den Bereich Prüfung."
        },
        "pay_viewingright1": {
            "tooltip": "Sichtrecht für den Bereich Bezahlen & Exportieren und Zahlungen entsprechend der Sichtrechte auf Anträge."
        },
        "export_viewingright1": {
            "tooltip": "Sichtrecht für den Bereich Bezahlen & Exportieren und Exporte entsprechend der Sichtrechte auf Anträge."
        },
        "subscriptions_viewingright1": {
            "tooltip": "Sichtrecht für alle Abonnements und Berechtigung zum Export der Abbonements Liste."
        },
        "subscriptions_viewingright2": {
            "tooltip": "Sichtrecht für alle Abteilungsabonnements."
        },
        "cards_viewingright1": {
            "tooltip": "Sichtrecht für alle Karten und damit verbundene Anträge (Unternehmensweit)."
        },
        "cards_viewingright2": {
            "tooltip": "Sichtrecht für alle Abteilungskarten und damit verbundene Anträge."
        },
        "cards_viewingright3": {
            "tooltip": "Sichtrecht für das Karten-Wallet, dessen Guthaben und Kontoauszüge."
        },
        "transactions_viewingright1": {
            "tooltip": "Sichtrecht für den Transaktionsbereich und Transaktionen."
        },
        "emplyees_viewingright1": {
            "tooltip": "Sichtrecht auf Detail-Informationen aller Mitarbeiter:innen des Unternehmens."
        },
        "employees_viewingright2": {
            "tooltip": "Sichtrecht auf Detail-Informationen der Abteilungsmitglieder."
        },
        "costcenter1_viewingright1": {
            "tooltip": "Sichtrecht für Kostenstellen entsprechend der Sichtrechte auf Anträge."
        },
        "vendors_viewingright1": {
            "tooltip": "Sichtrecht für den Bereich Lieferanten und Berechtigung zum Export der Lieferantenliste."
        },
        "vendors_viewingright2": {
            "tooltip": "Sichtrecht für Zahlungsdaten von Lieferanten."
        },
        "vendors_viewingright3": {
            "tooltip": "Sichtrecht für Lieferantenverträge."
        },
        "workflows_viewingright1": {
            "tooltip": "Sichtrecht für den Bereich Workfows."
        },
        "liquidity_viewingright1": {
            "tooltip": "Sichtrecht für den Bereich Liquidität."
        },
        "reporting_viewingright1": {
            "tooltip": "Sichtrecht für das Reporting."
        },
        "global_insights_viewingright1": {
            "tooltip": "Zugriff auf Globale Insights mit unternehmensweiten Auswertungen."
        },
        "settings_viewingright1": {
            "tooltip": "Sichtrecht für die Feature-Einstellungen."
        },
        "settings_viewingright2": {
            "tooltip": "Sichtrecht der folgenden buchhaltungsbezogenen Einstellungen: Sachkonten, Kostenträger, Steuersätze, Abteilungen, Tags und DATEV Integration."
        },
        "settings_viewingright3": {
            "tooltip": "Sichtrecht für Bankkonten innerhalb des Unternehmens."
        },
        "approval_requests": {
            "title": "Anträge",
            "tooltip": "Berechtigt zum Genehmigen, Bearbeiten und Ablehnen unternehmensweiter Anträge."
        },
        "approval_requests_status": {
            "title": "Status von Anträgen",
            "tooltip": "Berechtigt zum Bearbeiten des Status unternehmensweiter Anträge."
        },
        "approval_requests_team": {
            "title": "Anträge (Abteilung)",
            "tooltip": "Berechtigt zum Genehmigen, Bearbeiten und Ablehnen von Abteilungsanträgen."
        },
        "approval_requests_status_team": {
            "title": "Status von Anträgen (Abteilung)",
            "tooltip": "Berechtigt zum Bearbeiten des Status von Abteilungsanträgen."
        },
        "approval_dashboard": {
            "title": "Dashboard",
            "tooltip": "Berechtigt zum Genehmigen und Ablehnen von Anträgen direkt aus dem Übersichtsbereich im Dashboard."
        },
        "review_requests": {
            "title": "Anträge",
            "tooltip": "Berechtigt Anträge zu prüfen."
        },
        "payment_requests": {
            "title": "Anträge",
            "tooltip": "Berechtigt das Bezahlen von Anträgen."
        },
        "export_requests": {
            "title": "Anträge",
            "tooltip": "Berechtigt zum Exportieren von Anträgen in verschiedenen Formaten (z.B. CSV-Dateien, DATEV, [...])."
        },
        "subscriptions_company": {
            "title": "Unternehmen",
            "tooltip": "Berechtigt zum Erstellen, Bearbeiten und Löschen von Abonnements (Unternehmensweit)."
        },
        "subscriptions_team": {
            "title": "Abteilung",
            "tooltip": "Berechtigt zum Erstellen, Bearbeiten und Löschen von Abteilungsabonements."
        },
        "cards_company": {
            "title": "Unternehmen",
            "tooltip": "Berechtigt zum Bearbeiten und Austellen von Karten (Unternehmensweit)."
        },
        "cards_team": {
            "title": "Abteilung",
            "tooltip": "Berechtigt zum Bearbeiten und Austellen von Abteilungskarten."
        },
        "cards_wallet": {
            "title": "Wallet",
            "tooltip": "Berechtigt zum Aufladen des Wallets, Starten des KYB Prozesses, Aktivieren und Erhalten von Benachrichtigungen und zum erneuten Erstellen von Kontoauszügen."
        },
        "transactions_manage": {
            "title": "Verwalten",
            "tooltip": "Berechtigt zum Hinzufügen, Bearbeiten und Löschen von Transaktionen über den Import oder Bankverbindungen, sowie das Verknüpfen von Transaktionen mit Anträgen."
        },
        "employees_manage": {
            "title": "Verwalten",
            "tooltip": "Berechtigt zum Verwalten der Detail-Informationen aller Mitarbeiter:innen des Unternehmens."
        },
        "employees_conditions": {
            "title": "Auflagen",
            "tooltip": "Berechtigt zum Verwalten der Auflagen (z.B. Kostenstellen und Regeln) aller Mitarbeiter:innen des Unternehmens."
        },
        "employees_manage_team": {
            "title": "Verwalten (Abteilung)",
            "tooltip": "Berechtigt zum Verwalten der Detail-Informationen der Abteilungsmitglieder."
        },
        "employees_conditions_team": {
            "title": "Auflagen (Abteilung)",
            "tooltip": "Berechtigt zum Verwalten der Auflagen von Abteilungsmitgliedern (z.B. Kostenstellen und Regeln)."
        },
        "costcenter1_manage": {
            "title": "Verwalten",
            "tooltip": "Berechtigt zum Verwalten, Bearbeiten und Löschen von Kostenstellen und Budgets."
        },
        "costcenter1_approval": {
            "title": "Genehmigen",
            "tooltip": "Berechtigt, als Verantwortliche/-r einer Kostenstelle hinzugefügt zu werden."
        },
        "vendors_manage": {
            "title": "Verwalten",
            "tooltip": "Berechtigt zum Hinzufügen, Bearbeiten und Löschen von Lieferanten."
        },
        "vendors_paymentdata": {
            "title": "Zahlungsdaten",
            "tooltip": "Berechtigt zum Bearbeiten oder Löschen von Zahlungsdetails aller Lieferanten."
        },
        "vendors_contracts": {
            "title": "Verträge",
            "tooltip": "Berechtigt zum Hochladen oder Löschen von Lieferanten-Verträgen."
        },
        "workflows_manage": {
            "title": "Verwalten",
            "tooltip": "Berechtigt zum Verwalten von Workflows."
        },
        "workflows_overwrite": {
            "title": "Überschreiben",
            "tooltip": "Berechtigt zum Überschreiben eines aktiven Workflows eines Antrags."
        },
        "liquidity_manage": {
            "title": "Verwalten",
            "tooltip": "Berechtigt zum Verwalten des Liquiditätsmanagements."
        },
        "feature_settings_manage": {
            "title": "Feature-Einstellungen",
            "tooltip": "Berechtigt zum Bearbeiten der Feature-Einstellungen."
        },
        "accounting_settings_manage": {
            "title": "Buchhaltungseinstellungen",
            "tooltip": "Berechtigt zum Bearbeiten der folgenden buchhaltungsbezogenen Einstellungen: Sachkonten, Kostenträgern, Steuersätzen, Abteilungen und DATEV Integration. Zusätzlich berechtigt es Nutzer:innen, Tags zu erstellen und zu löschen."
        },
        "settings_bankaccounts": {
            "title": "Bankkonten",
            "tooltip": "Berechtigt zum Hinzufügen, Bearbeiten und Löschen von Bankkonten."
        },

        "procurement_viewing_right": {
            "tooltip": "Sichtrecht für den Bereich Einkauf und die Bestellungen in Einkaufsfreigabe ({{states}})."
        },

        "procurement_manage_right": {
            "tooltip": "Berechtigt Bestellungen in Auftrag zu geben.",
            "title": "Bestellungen"
        },
        "delivery_note_viewing_right": {
            "tooltip": "Sichtrecht für alle Lieferscheine innerhalb des Unternehmens."
        },
        "delivery_note_update_right": {
            "title": "Lieferschein",
            "tooltip": "Berechtigt zum Bearbeiten und Löschen unternehmensweiter Lieferscheine."
        }
    },

    "per_diem_calculation": "Tagesberechnung",
    "trip_map": "Karte",
    "tag": "Tag",
    "tags": "Tags",
    "available": "<0></0> verfügbar",
    "above_limit": "Limit überschritten um <0></0>",
    "sub_company_email_aliases": "Firmen Email-Alias",
    "no_email_alias_set": "Kein Email-Alias gesetzt",
    "add_email_alias": "Email-Alias hinzufügen",
    "alternative_email_address_required": "Alternative Email-Adresse nötig",
    "or": "oder",
    "csv_settings": {
        "custom_csv_template": "Benutzerdefinierte CSV Vorlagen",
        "set_up": "Erstellen",
        "add_field": "Hinzufügen",
        "total_templates": "Insgesamt {{numberOfTemplates}} Vorlagen",
        "edit": "Vorlage bearbeiten",
        "new": "Neue Vorlage"
    },
    "auto_logout": {
        "title": "Inaktivitäts-Logout",
        "fifteen_minutes": "Nach 15 Minuten",
        "one_hour": "Nach 60 Minuten",
        "one_work_day": "Nach 1 Tag (8 Stunden)",
        "one_full_day": "Nach 1 Tag (24 Stunden)"
    },
    "fiscal_year": "Geschäftsjahr",
    "custom_bank_subject": {
        "title": "Individualisierter Verwendungszweck",
        "invoice_number": "Rechnungsnummer",
        "expense_number": "Ausgabennummer",
        "vendor_name": "Lieferant",
        "description": "Beschreibung",
        "request_items": "Antragsartikel",
        "not_set": "Nicht gesetzt"
    },
    "pdf": "PDF",
    "payment_flow_information": {
        "title": "Bezahlungsstatus",
        "not_set": "Nicht gesetzt",
        "already_paid": "Bereits bezahlt (z.B. SEPA)",
        "already_approved_and_paid": "Bereits genehmigt & bezahlt",
        "reporting_only": "Nur für Reporting"
    },
    "expense_payment_flow_information": {
        "is_already_approved_and_paid_enabled": "\"Genehmigt & bezahlt\"-Prozess (Genehmigung & Zahlung überspringen)",
        "is_already_paid_enabled": "\"Bereits bezahlt\"-Prozess (Zahlung überspringen)",
        "is_report_only_enabled": "\"Nur Reporting\"-Prozess (Genehmigung, Bezahlung & Export überspringen)"
    },
    "debit_card_limit_buffer": "Limit-Puffer für Debitkarten",
    "set_employee_rule": "MitarbeiterInnenregeln definieren",
    "set_employee_limits": "Mitarbeiter:innen Limits definieren",
    "vendorRulesShouldOverwrite": "Lieferanten-Regeln sollen MitarbeiterInnenregeln überschreiben",
    "allow_all_to_update_absences": "Urlaubs- und Krankheitsvertretung: Allen Nutzer:innen erlauben, ihre Abwesenheiten zu hinterlegen",
    "show_cost_centers_ids": "Kostenstellen IDs in Drop-down-Menüs anzeigen",
    "amount_payable": "Zahlungsbetrag (brutto)",
    "show_auto_approver_warning": "Auto-Approver Warnung",
    "custom_datev_modal": "Benutzerdefinierte DUO Notiz und Buchungstext",
    "custom_datev_booking": "DATEV Buchungstext",
    "custom_datev_information": "Benutzerdefinierte DUO Notiz",
    "custom_datev_settings": "Benutzerdefinierte(r) DATEV Notiz & Buchungstext",
    "root_company": "Hauptfirma",
    "comment_date_time_format": "DD.MMM YYYY, HH:mm",
    "request_status": "Antragsstatus",
    "request_details": "Antragsdetails",
    "n/a": "N/A",
    "not_provided": "nicht bereitgestellt",
    "provided": "bereitgestellt",
    "standard_reimbursement": "Standard-Erstattung",
    "mileage_reimbursement": "Kilometerpauschalen-Erstattung",
    "per_diem_reimbursement": "Verpflegungsmehraufwands-Erstattung",
    "hospitality_reimbursement": "Bewirtungs-Erstattung",
    "all_reimbursements": "Alle Erstattungen",
    "filter_presets": {
        "overdue_invoices": "Überfällige Rechnungen",
        "my_todo": "Meine To-dos",
        "my_requests": "Meine Anträge",
        "follow_up_requests": "Wiedervorlage",
        "draft_trip_folder": "Alle Reiseentwürfe",
        "my_mentions": "Meine Erwähnungen"
    },
    "quick_filter": "Schnellfilter",
    "fallback_approver": "Ersatz-Genehmiger:in",
    "define_fallback_approver": "Ersatz-Genehmiger:in definieren",
    "approvals": "Genehmigungen",
    "purchase_approval": "Kaufgenehmigung",
    "invoice_approval": "Rechnungsgenehmigung",
    "file_download": "Ihr {{fileName}} Download startet in Kürze",
    "renewal_generation": {
        "title": "Generierung von wiederkehr. Anträgen",
        "by_date": "Mittels Datum",
        "by_transaction": "Mittels Transaktion"
    },
    "created_by": "Ersteller:in",
    "date_created": "Erstellungsdatum",
    "company_identifier": "Firmenidentifikation",
    "update_expense_amount_on_card_transaction": "Beträge automatisch anpassen",
    "purchase_submit_confirmation": "Diesen Kaufantrag einreichen?",
    "invoice_submit_confirmation": "Diese Rechnung einreichen?",
    "request_submit_confirmation_description": "Bitte stellen Sie sicher, dass alle Daten korrekt und vollständig sind. Dadurch werden die Genehmiger:innen benachrichtigt.",
    "folder_submit_confirmation_description": "Bitte sammeln Sie alle Kosten vor dem Absenden. Dadurch werden die Genehmiger benachrichtigt.",
    "recalculate_approval_process_after_amount_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich der Betrag in einem Antrag verändert.",
    "recalculate_approval_process_after_folder_amount_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich der Betrag in einer Reise verändert.",
    "recalculate_approval_process_after_other_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich bestimmte Daten in einem Antrag verändern.",
    "recalculate_approval_process_after_folder_other_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich bestimmte Daten in einer Reise verändern.",
    "approval_process_status": {
        "not_started": "Nicht gestartet",
        "in_progress": "Aktiv",
        "approved": "Freigegeben",
        "rejected": "Abgelehnt",
        "skipped": "Übersprungen"
    },
    "draft_trip_folder": "Reiseentwürfe",
    "trip_folder_request": "Reise",
    "trip_folder_request_desc": "Reiseordner für Reise erstellen",
    "draft": "Entwurf",
    "trip_folder": "Reise",
    "shared": "Geteilt",
    "free_delivery": "Kostenlose Lieferung",
    "tax_id": "Steuer-ID",
    "logout": "Ausloggen",
    "personio": {
        "title": "Personio",
        "importedTooltip": "Mitarbeiter:in wurden von Personio importiert.",
        "easily_setup": "Verbinden Sie Personio und finway, um Mitarbeiter:innen Daten und Abwesenheiten zu synchronisieren.",
        "how_to_obtain_client_id": "Wie bekommt man eine client ID?",
        "enable_absence_sync": {
            "title": "Abwesenheiten synchronisieren",
            "tooltip": "Wenn “Abwesenheiten synchronisieren” aktiviert ist, werden Mitarbeiter:innen mit einer Abwesenheit in Personio auch in finway als abwesend angezeigt. Wenn ein Workflow von einer Abwesenheit betroffen ist, wird der Fallback-Genehmigungsprozess ausgelöst."
        },
        "enable_create_employee": {
            "title": "Mitarbeiter:innen importieren",
            "tooltip": "Wenn “Mitarbeiter:innen importieren” aktiviert ist, werden Mitarbeiter, die noch nicht in Personio sind, automatisch zu Ihrem finway-Konto hinzugefügt."
        },
        "enable_employee_sync": {
            "title": "Bestehende Mitarbeiter:innen updaten",
            "tooltip": "Wenn “Bestehende Mitarbeiter:innen updaten” aktiviert ist, aktualisiert finway die Mitarbeitendeninformationen, die im Mitarbeitendenprofil in Personio geändert wurden."
        },
        "enable_team_sync": {
            "title": "Abteilungen hinzufügen",
            "tooltip": "Wenn “Abteilungen hinzufügen” aktiv ist, wird eine “Abteilung” in Personio, die noch nicht als “Abteilung” in finway angelegt ist, automatisch erstellt."
        },
        "settings": {
            "title": "Einstellungen",
            "employee_email_required": "Bitte stellen Sie sicher, dass alle Benutzer:innen, die synchronisiert werden sollen, in Personio eine E-Mail-Adresse hinterlegt haben."
        },
        "exclusion_list": "Ausschlussliste",
        "exclusion_list_explanation": "Bitte fügen Sie die Benutzer:innen-Email-Adressen hinzu, die Sie von der Personio-Synchronisierung ausschließen möchten.",
        "excludedUser_one": "Ausgeschlossene:r Nutzer:in ({{count}})",
        "excludedUser_other": "Ausgeschlossene Nutzer:innen ({{count}})"
    },
    "sso": {
        "title": "Single Sign-On (SSO)",
        "text": "Wählen Sie den Single Sign-On (SSO) Anbieter der de-/aktiviert werden soll:",
        "providers": {
            "google": {
                "title": "Google",
                "desc": "Erlaubt den Login durch Google"
            },
            "azure_ad": {
                "title": "Microsoft Entra ID",
                "desc": "Erlaubt den Login durch Microsoft Entra ID"
            },
            "okta": {
                "title": "Okta",
                "desc": "Erlaubt den Login durch Okta"
            }
        },
        "how_to_obtain_client_id": "Wie bekommt man eine client ID?",
        "config": {
            "origins": "Erlaubte JavaScript origins",
            "redirects": "Erlaubte Weiterleitungs-URIs"
        },
        "easily_setup": "Richten Sie Ihre gewerbliche SSO Verbindung einfach und schnell ein.",
        "connection": {
            "successfully_setup": "{{providerName}} erfolgreich verbunden",
            "test": "Verifizieren Sie das die Verbindung gänzlich funktioniert indem Sie die Verbindung testen."
        },
        "enforce": "Erlaube nur die Nutzung von SSO",
        "warning": {
            "title": "Warnung",
            "enforce": "Alle Nutzer:innen werden sich nur noch durch SSO sich authentifizieren können, dass heißt alle Nutzer:innen außerhalb Ihrer SSO-Verknüpfung werden keinen Zugang mehr haben. Sind Sie sicher das dies passieren soll?",
            "deforce": "Alle Nutzer:innen werden sich ab sofort nicht mehr nur mit SSO authentifizieren können. Sind Sie sicher das dies passieren soll?"
        }
    },
    "mfa": {
        "title": "Multi-Faktor-Authentifizierung (MFA)",
        "enforce": "Erfordere die Nutzung von MFA",
        "warning": {
            "title": "Warnung",
            "enforce": "Alle Nutzer:innen werden aufgefordert eine MFA option einzurichten die für zukünftige Logins benötigt wird. Sind Sie sicher das dies passieren soll?",
            "deforce": "Hiermit wäre es keine Pflicht mehr MFA zu nutzen. Sind Sie sicher das dies so sein soll?"
        },
        "reset_for_user": {
            "button": "MFA einstellung zurücksetzen",
            "desc": "Dies setzt jegliche MFA Konfiguration von diesem/dieser Nutzer:in zurück, falls bereits eine oder mehrere hinterlegt ist."
        }
    },
    "change_history": "Änderungsprotokoll",
    "type_x_to_proceed": "Schreibe {{string}} um fortzufahren",
    "copy": "Kopieren",
    "learn_more": "Erfahre mehr",
    "coming_soon": "Bald verfügbar",
    "back_to_login": "Zum Login",
    "trip_folder_title": "Reise",
    "trip_folder_info": "Reisekostenerstattungen leicht gemacht",
    "allow_expense_account_code_special_characters": "Sonderzeichen in Sachkonten Codes erlauben",
    "trip_folder_request_info": {
        "step_1": "Wir empfehlen Ihnen, diese Reise zu erstellen und zu speichern.",
        "step_2": "Kostenstelle und Kostenträger, sowie die hier eingestellten Sachkonten werden in Anträgen vorausgefüllt, die Sie direkt in dieser Reise erstellen.",
        "step_3": "Bitte speichern Sie diese Reise und reichen Sie ihn erst dann ein, wenn Sie alle Reise bezogenen Ausgaben, Rechnungen und Anträge hinzugefügt haben.",
        "step_4": "In dieser Reise können Sie neue Anträge erstellen, z.B. für die Fahrtkostenerstattung, Rückerstattung von Bewirtungskosten oder Verpflegungsmehraufwand, sowie für weitere Rückerstattungen oder Rechnungsanträge.",
        "step_5": "Außerdem können Sie dieser Reise bestehende Anträge hinzufügen, z.B. Kartenanträge, Rechnungsanträge für eine Hotelübernachtung, etc.",
        "step_6": "Reichen Sie Ihre Reise ein, wenn Sie alle bestehenden, sowie alle neu erstellten Reise bezogenen Anträge hinzugefügt haben.",
        "step_7": "Bitte stellen Sie sicher, dass Sie Ihre Bankverbindung in Ihrem Mitarbeiterprofil hinterlegt haben, damit Sie die Erstattungszahlungen erhalten können."
    },
    "billable": "Weiterverrechenbar",
    "vendor_data_changed": "Wir haben eine Diskrepanz zwischen den Lieferantenstammdaten und den Informationen des Lieferanten in diesem Antrag festgestellt. Klicken Sie hier, um den Antrag mit den Lieferantenstammdaten zu synchronisieren.",
    "resources": {
        "expense": "Anträge",
        "vendor": "Lieferanten",
        "costcenter": "Kostenstellen",
        "subscription": "Abonnement",
        "costcenter2": "Kostenträger",
        "user": "Nutzer:innen",
        "matchingtransaction": "Transaktionen",
        "companysettings": "Firmen",
        "role": "Rollen",
        "wallet": "Wallets",
        "bankconnection": "Bankverbindungen",
        "card": "Karten",
        "corporate": "Corporates",
        "expensetag": "Tags auf Anträgen",
        "inboxinvoice": "Rechnungseingang",
        "tax": "MwSt.",
        "team": "Abteilungen",
        "workflow": "Workflows",
        "csvtemplate": "Benutzerdefinierte CSV Vorlagen",
        "expenseaccount": "Sachkonten",
        "vendorpayment": "Lieferantenzahlungen",
        "purchaseorder": "Bestellungen"
    },
    "export_history": {
        "title": "Export Historie",
        "export_date": "Datum des Exports",
        "resource": "Ressource",
        "format": "Format",
        "download": "Download",
        "status": {
            "title": "Status",
            "done": "Erledigt",
            "processing": "In Bearbeitung",
            "failed": "Fehlgeschlagen",
            "partially_failed": "Teilweise fehlgeschlagen"
        },
        "actions": "Aktionen",
        "validation": {
            "title_format": "Exportvalidierung für {{format}}",
            "title": "Exportvalidierung",
            "expense": "Antrag",
            "status": "Status",
            "message": "Nachricht",
            "success_message": "Validierung bestanden"
        }
    },
    "duo_import_protocol": {
        "title": "DUO Import Protokoll",
        "type": "Typ",
        "filename": "Dateiname",
        "text": "text",
        "time": "Uhrzeit"
    },
    "expense_status": {
        "purchase_pending": "Einkaufsfreigabe",
        "docs_needed": "Dokumente erforderlich",
        "invoice_pending": "Rechnungsfreigabe",
        "approved": "Genehmigt",
        "reviewed": "Geprüft",
        "paid": "Bezahlt",
        "done": "Exportiert",
        "declined": "Abgelehnt"
    },
    "user_password_reset": {
        "title": "Passwort für Nutzer:in zurücksetzen",
        "explainer": "Falls dieses Nutzerkonto ein Password aktiv hat, wird dieses zurückgesetzt und zeitgleich alle aktive Sessions aufgelöst. Der/die Nutzer:in erhält einen Link um ein neues Passwort zu setzen und der/die Nutzer:in verliert sofort zugriff auf Finway bis ein neues Password gesetzt ist."
    },
    "unblock_user": {
        "title": "Nutzer:in entsperren",
        "explainer": "Wenn ein:e Benutzer:in gesperrt wurde aufgrund zu vieler falsche Anmeldedaten, können Sie die Sperrung hier aufheben"
    },
    "multi_currency_wallet": "Wallet in verschiedenen Währungen",
    "account_number": "Account Nummer",
    "sort_code": "Sort Code",
    "gobd": {
        "enforce_belegfunktion": "GoBD-konformes Arbeiten",
        "invoice_compliance_date": "CPU Datum"
    },
    "invoice_complance_date": "CPU-Datum",
    "happy_easter": "Frohe Ostern!",
    "email_forwarding_address": "Email Weiterleitungsadresse",
    "comments_and_mentions": "Kommentare & Erwähnungen",
    "inbox_invoice": "Rechnungseingangs-Beleg",
    "reset_demo_data": "Demodaten zurücksetzen",
    "root_user_email_reverification": "Karten Root Nutzer:in Email-Verifizierung",

    "cs_feature_flags": {
        "export_api": "Aktiviere die Export-API für diese Kundeninstanz",
        "personio_integration": "Aktiviere die Personio-Integration für diese Kundeninstanz",
        "owt": "Aktiviere Outgoing Wire Transfer für diese Kundeninstanz",
        "p2p": "Aktiviere P2P für diese Kundeninstanz",
        "purchase_requests": "Aktiviere die Kaufanträge für diese Kundeninstanz",
        "vendor_payment_netting": "Aktiviere die Lieferantenverrechnung (Beta) für diese Kundeninstanz"
    },
    "datev_csv_config": {
        "title": "Konten für DATEV CSV Wallet & Sachkontenlänge",
        "info": "Tragen Sie hier die DATEV Kontennummern für das finway Wallet Konto und das Geldtransitkonto in das jeweilige Feld ein (z.B. 1460 Geldtransit im SKR04)."
    },
    "datev_client_and_consultant": {
        "title": "DATEV Mandanten- & Beraternummer",
        "info": "Bitte geben Sie Ihre DATEV Mandanten- & Beraternummer ein"
    },
    "date_format": {
        "month_year": "MM.YYYY"
    },
    "e_invoice_type": {
        "commercial_invoice": "Handelsrechnung",
        "insurance": "Versicherung",
        "corrected_invoice": "Rechnungskorrektur",
        "request_for_payment": "Zahlungsaufforderung",
        "debit_note_goods_services": "Belastungsanzeige (Waren/Dienstleistungen)",
        "metered_services_invoice": "Rechnung für gemessene Dienstleistungen",
        "debit_note_financial_adjustments": "Belastungsanzeige (finanzielle Anpassungen)",
        "tax_notification": "Steuerbenachrichtigung",
        "final_payment_request": "Schlussrechnung",
        "payment_request_completed_units": "Zahlungsaufforderung für abgeschlossene Einheiten",
        "commercial_invoice_with_packing": "Handelsrechnung mit Packliste",
        "commission_note": "Provisionsnotiz",
        "debit_note": "Belastungsanzeige",
        "prepayment_invoice": "Vorauszahlungsrechnung",
        "tax_invoice": "Steuerrechnung",
        "factored_invoice": "Abgetretene Rechnung",
        "consignment_invoice": "Konsignationsrechnung",
        "forwarders_invoice_discrepancy": "Spediteur-Rechnungsabweichung",
        "forwarders_invoice": "Spediteurrechnung",
        "freight_invoice": "Frachtrechnung",
        "claim_notification": "Schadensmeldung",
        "consular_invoice": "Konsularrechnung",
        "partial_construction_invoice": "Teilbaurechnung",
        "partial_final_construction_invoice": "Teilschlussrechnung für Bauvorhaben",
        "final_construction_invoice": "Endabrechnung für Bauvorhaben",
        "invoice": "Rechnung"
    },
    "vat_breakdown": "MwSt. Aufschlüsselung",
    "category": "Kategorie",
    "tax_base_amount": "Steuerbasisbetrag",
    "tax_amount": "Steuerbetrag",
    "invoice_summary": "Rechnungssumme",
    "total_item_amount": "Gesamtbetrag",
    "total_surcharges": "Zusatzkosten",
    "total_discounts": "Rabatt",
    "subtotal_net_amount": "Nettobetrag",
    "total_vat_amount": "MwSt.",
    "subtotal_gross_amount": "Bruttobetrag",
    "advance_payments": "Vorauszahlungen",
    "amount_due": "Zahlungsbetrag",
    "itemized_charges": "Auflistung der Positionen",
    "net_price": "Nettobetrag",
    "qty": "Menge",
    "gross_price": "Bruttobetrag",
    "generated_by": "Erstellt von",
    "invoice_details": "Rechnungsdetails",
    "seller_information": "Verkäuferinformationen",
    "buyer_service_recipient": "Käufer/Serviceempfänger",
    "vat_id": "Umsatzsteuer-ID",
    "invoice_number": "Rechnungsnummer",
    "invoice_type": "Rechnungsart",
    "payment_terms": "Zahlungsbedingungen",
    "no_liability_message": "Wir übernehmen keine Gewähr für die Richtigkeit der Daten.",
    "update_sepa_version": "SEPA xml Version (pain.001.001.09)",
    "vendor_payment_netting": "Lieferantenverrechnung",
    "new_feature": "Neues Feature",
    "line_items": "Artikel",
    "purchase_order_link_disabled": "Um diese Rechnung mit einer bestehenden Bestellung zu verknüpfen, fügen Sie bitte die Artikel hinzu.",
    "purchase_orders_selection_modal": {
        "title": "Bestellungen"
    },
    "po_link": {
        "auto_link_tooltip_title": "Automatische Artikelverknüpfung durch KI 🚀",
        "auto_link_tooltip": "Unsere KI analysiert Ihre Bestellung und erstellt die Verknüpfungen zu den passenden Artikeln.",
        "auto_link_tooltip_title_coming_soon": "Automatische Artikelverlinkung 🚀",
        "auto_link_tooltip_coming_soon": "Bald erledigt finway die Verlinkung automatisch für Sie.",
        "auto_matching_in_progress": "KI verknüpft Rechnungspositionen mit Bestellungen...",
        "no_auto_match_results": "Die KI konnte für die ausgewählte Bestellung keinen passenden Artikel finden.",
        "all_items_linked": "Alle Artikel sind bereits verknüpft",
        "all_po_items_linked": "Alle Bestellpositionen sind bereits verknüpft",
        "purchase_order_line_items": "Bestellpositionen",
        "invoice_line_items": "Rechnungspositionen",
        "unitPrice": "Einzelpreis",
        "totalGross": "Brutto",
        "quantity": "Menge",
        "quantityReceived": "Menge erhalten",
        "amountInvoiced": "In Rechnung gestellt",
        "item_linked_to_purchase_order": "Artikel ist mit {{po_number}} verlinkt",
        "quantity_ordered": "Bestellte Menge",
        "previously_received": "Bereits erhaltene Menge",
        "open_quantity": "Offene Menge",
        "delivery_note_line_items": "Lieferscheinpositionen"
    },
    "linked_to_this_invoice": "Mit dieser Rechnung verknüpft",
    "linked_to_this_delivery_note": "Mit diesem Lieferschein verknüpft",
    "purchase_orders": "Bestellungen",
    "purchase_order": "Bestellung",
    "embedded_attachments": "Eingebettete Anhänge",
    "purchase_order_short": "PO",
    "skr42": "SKR42 (Vereine)",
    "opos": {
        "title": "OPOS Liste",
        "filter": {
            "vendor": "Lieferant",
            "dueDate": "Fälligkeit",
            "status": "Zahlungsstatus",
            "marked_as_paid": "\"Als bezahlt\" markierte Anträge",
            "marked_as_paid.exclude": "Aus OPOS ausschließen"
        },
        "invoice_number": "Rechnungsnummer",
        "vendor_name": "Lieferant",
        "vendor_creditor_number": "Kreditorennummer",
        "invoice_date": "Rechnungsdatum",
        "due_date": "Fälligkeit",
        "due_today_short": "Heute",
        "payment_terms": "Zahlungsbedingungen",
        "agreed_payment_conditions": "Vereinbarte Zahlungsbedingungen",
        "original_amount": "Ursprünglicher Betrag",
        "open_amount": "Offener Betrag",
        "open_amount_net": "Offener Betrag (netto)",
        "open_amount_gross": "Offener Betrag (brutto)",
        "currency": "Währung",
        "status": {
            "open": "Offen",
            "due": "Überfällig",
            "overdue": "Überfällig",
            "paid": "Bezahlt",
            "failed": "Fehler"
        },
        "days_overdue": "Tage überfällig",
        "expense_accounts": "Sachkonto",
        "performance_date": "Leistungsdatum",
        "request": "Antrag",
        "open_amount_gross_total": "Offener Betrag (brutto)",
        "open_amount_with_skonto_gross": "Offener Betrag mit Skonto (brutto)",
        "currency_total": "{{currency}} Gesamt",
        "invoices_count": "{{count}} Rechnungen",
        "show_skonto": "Skonto anzeigen",
        "savings": "Ersparnis",
        "discount_percent": "Skonto %",
        "discount_due_date": "Skonto Fälligkeit",
        "total_gross_with_discount": "Betrag mit Skonto (brutto)",
        "refund": "Erstattung",
        "action": "Aktion",
        "clear_item": "Posten ausschließen",
        "tabs": {
            "open_items": "Offene Posten",
            "excluded": "Ausgeschlossene Posten"
        }
    },
    "self_issued_receipt": "Eigenbeleg",
    "vendor_payments": {
        "documents_netted_one": "{{count}} Beleg in 1 Zahlung verrechnet",
        "documents_netted_other": "{{count}} Belege in 1 Zahlung verrechnet",
        "method": "Methode",
        "net_payment": "Nettozahlung",
        "subject_line": "Verwendungszweck",
        "new": "Neu",
        "promo_title": "Jeden Lieferanten nur einmal bezahlen - automatisch",
        "promo_description": "finway verrechnet offene Rechnungen und Gutschriften eines Lieferanten zu <0>einer Zahlung pro Lieferant</0> und hält dabei jeden Buchungsbeleg getrennt und prüfbar.",
        "promo_netted_per_vendor": "Rechnungen und Lieferantengutschriften pro Lieferant verrechnet",
        "promo_one_payment": "Eine SEPA-Zahlung, GoBD-konform nachvollziehbar",
        "promo_card_excluded": "Kartengutschriften werden automatisch ausgeschlossen",
        "promo_example_vendor": "Muster GmbH",
        "promo_example_documents": "#33 - 2 Rechnungen, 1 Gutschrift",
        "promo_example_net": "Nettozahlung",
        "promo_example_invoice": "Rechnung {{number}}",
        "promo_example_credit_note": "Gutschrift {{number}}",
        "title": "Lieferantenzahlungen",
        "invoice_count_one": "{{count}} Rechnung",
        "invoice_count_other": "{{count}} Rechnungen",
        "credit_note_count_one": "{{count}} Gutschrift",
        "credit_note_count_other": "{{count}} Gutschriften",
        "pending_credit_notes_one": "{{count}} Gutschrift nicht freigegeben",
        "pending_credit_notes_other": "{{count}} Gutschriften nicht freigegeben",
        "excluded": "Ausgeschlossen",
        "pending": "Ausstehend",
        "excluded_credit_notes": "Ausgeschlossene Gutschriften",
        "block_reason": {
            "credit_exceeds_invoices": "Gutschriften übersteigen die Rechnungen",
            "credit_equals_invoices": "Gutschriftbetrag entspricht dem Rechnungsbetrag",
            "no_invoices": "Keine Rechnung ausgewählt",
            "missing_iban": "IBAN des Lieferanten fehlt"
        },
        "single_title": "Lieferantenzahlung",
        "system": "System",
        "status": {
            "approved": "Freigegeben",
            "payment_initiated": "Zahlung gestartet",
            "exported": "Exportiert",
            "paid": "Bezahlt",
            "failed": "Fehlgeschlagen",
            "cancelled": "Storniert"
        },
        "log": {
            "created": "Erstellt",
            "approved": "Freigegeben",
            "payment_initiated": "Zahlung gestartet",
            "exported": "Als SEPA XML exportiert",
            "paid": "Bezahlt",
            "payment_failed": "Zahlung fehlgeschlagen",
            "cancelled": "Storniert",
            "matched": "Mit Banktransaktion verknüpft",
            "unmatched": "Von Banktransaktion getrennt",
            "document_reset": "Beleg zurückgesetzt"
        }
    }
}
